/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable function-paren-newline */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import { Col, MultiSelection, Row, Selection } from '@folio/stripes-components';
import useDataByName from '../../../../../../hooks/useDataByName';

const propTypes = {
  fieldName: PropTypes.string,
  fieldData: PropTypes.object,
};

function LocationFieldType({ fieldName, fieldData }) {
  const data = useDataByName('locations');
  const intl = useIntl();

  // Filter active locations and format them for display
  const handleLocationOptions = () => {
    const options = [];
    (data || []).forEach((location) => {
      if (location.isActive) {
        options.push({
          value: location.id,
          originalName: location.name,
          code: location.code,
          label: location.name, // Will be formatted in formatter
        });
      }
    });
    return options;
  };

  const getSelectedLocationOptions = () => {
    const availableOptions = handleLocationOptions();
    const selectedIds =
      fieldData?.dataOptionsLimits?.map((item) => item.value) || [];

    return availableOptions.filter((option) =>
      selectedIds.includes(option.value),
    );
  };

  const formatter = ({ option }) => {
    const translatedName = intl.formatMessage({
      id: `ui-tenant-settings.locations.name.${option.originalName}`,
      defaultMessage: option.originalName,
    });

    return (
      <div>{`${translatedName}${option.code ? ` (${option.code})` : ''}`}</div>
    );
  };

  const defaultValueFormatter = () => {
    const selectedOptions = getSelectedLocationOptions();

    return selectedOptions.map((opt) => {
      const translatedName = intl.formatMessage({
        id: `ui-tenant-settings.locations.name.${opt.originalName}`,
        defaultMessage: opt.originalName,
      });

      return {
        label: `${translatedName}${opt.code ? ` (${opt.code})` : ''}`,
        value: opt.value,
      };
    });
  };

  return (
    <Row>
      <Col xs={6}>
        <Field
          id={`${fieldName}.dataOptionsLimits`}
          name={`${fieldName}.dataOptionsLimits`}
          type="text"
          component={MultiSelection}
          itemToString={(item) => (item ? item.value : '')}
          dataOptions={handleLocationOptions()}
          formatter={formatter}
          fullWidth
          label={
            <FormattedMessage
              id="ui-plugin-inventory-templates.templateField.locationOptions.label"
              defaultMessage="Location options"
            />
          }
        />
      </Col>
      <Col xs={6}>
        <Field
          name={`${fieldName}.defaultValue`}
          type="text"
          component={Selection}
          dataOptions={[
            {
              label: intl.formatMessage({
                id: 'ui-plugin-inventory-templates.templateField.locationDefaultValue.choose',
                defaultMessage: 'Choose default location',
              }),
              value: '',
            },
            ...defaultValueFormatter(),
          ]}
          fullWidth
          label={
            <FormattedMessage
              id="ui-plugin-inventory-templates.templateField.locationDefaultValue.label"
              defaultMessage="Default location"
            />
          }
        />
      </Col>
    </Row>
  );
}

LocationFieldType.propTypes = propTypes;

export default LocationFieldType;
